<div class="page_not_found_area">
  <img src="../../../assets/main/page-not-found.png" class="page_not_found_image" alt="Page not found">
  <p class="main_title">Something went wrong</p>
  <p class="sub_title">Our team is working hard to bring it back up</p>
</div>
